(function ($, root, undefined) {

  $(function () {

    'use strict';

    // https://github.com/miguel-perez/smoothState.js
    // var $body = $('body');
    // var $loader = $('#loader');
    // var $transition = $('.transition-box');

    // var $page = $('#main'),
    // options = {
    //   debug: true,
    //   blacklist: ".no-smoothstate, a[href*='.jpg'], a[href*='.png'], a[href*='.jpeg'], a[href*='.pdf']",
    //   prefetch: false,
    //   loadingClass: 'onload',
    //   scroll: false,
    //   cacheLength: 0,
    //   forms: 'search',
    //   onStart: {
    //     duration: 0, // Duration of our animation
    //     render: function ($container) {
    //       // Add your CSS animation reversing class
    //       // $container.addClass('onload');
    //       // $loader.addClass("start");
    //       // Restart your animation
    //       smoothState.restartCSSAnimations();
    //       $body.addClass("beforeload");
    //     }
    //   },
    //   onProgress: {
    //     // How long this animation takes
    //     duration: 1300,
    //     // A function that dictates the animations that take place
    //     render: function ($container) {
    //       $body.removeClass("loaded");
    //       $transition.addClass("moving-effect");
    //       $body.removeClass("beforeload");
    //       // $body.addClass("onload");
    //     }
    //   },
    //   onReady: {
    //     duration: 0,
    //     render: function ($container, $newContent) {
    //       // Remove your CSS animation reversing class
    //       // $container.removeClass('onload');
    //       // $body.removeClass("onload");
    //       $body.addClass("loaded");
    //       $transition.removeClass("moving-effect");
    //       // $(".wrapLoader").removeClass("loading");
    //       // Inject the new content
    //       $container.html($newContent);
    //       $('html, body').animate({ scrollTop: 0 }, 0);
    //       initSite();
    //     }
    //   },
    //   onAfter : function($container, $newContent) {
    //       // $body.removeClass("onload");
    //       // $loader.removeClass("start");
    //   }
    // },
    // smoothState = $page.smoothState(options).data('smoothState');

    // -------- End smoothState ------------


    // Fonction fixe navigation

    // fixeNav();

    // function fixeNav() {
    //   var header = $("html");
    //   $(window).scroll(function() {
    //     var scroll = $(window).scrollTop();
    //       if (scroll >= 60) {
    //           header.addClass("navfixed");
    //       } else {
    //           header.removeClass("navfixed");
    //       }
    //   });
    // }

    // $(window).scroll(function() {
    //   var scroll = $(window).scrollTop();
    //   $(".zoom").css({
    //   backgroundSize: (100 + scroll/20)  + "%",
    //   bottom: -(scroll/10)  + "%",
    //       });
    // });


    // $('.nav a[href^="/#"]').on('click', function (e) {
    //  $('#toggle-nav').removeAttr('checked');
    // });

    // $('.nav a').on('click', function (e) {
    //   $('#toggle-nav').removeAttr('checked');
    // });


    initSite();

    function initSite() {

      // console.log("INIT SITE");

      var $homeVideo = null;
      var player_homeVideo = null;

      if ($('#video-home video').length) {
        var video = $("#video-home video");
        // $('document').trigger('click');
        video[0].load();
        video[0].play();
      }

      // Si l'on est sur la Home

      if ($('body').hasClass('home')) {

      } else {
        // console.log("Pas la Home !!");
      }

      $("#slider").owlCarousel({
        items: 1,
        loop: false,
        autoplay: true,
        mouseDrag: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: false,
        nav: false,
        navText: [ '<', '>' ],
        dots: true,
        smartSpeed: 700,
        animateOut: 'fadeOut',
        // dotsContainer: '.navSlide',
        responsiveClass:true,
        responsive:{
            0:{
                nav:false
            },
            600:{

            },
            979:{

            }
        }
      });


      $(".sliderDiaporama").owlCarousel({
        items: 1,
        loop: false,
        center: true,
        autoplay: false,
        mouseDrag: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: false,
        nav: true,
        navText: [ '', '' ],
        dots: false,
        smartSpeed: 700,
        responsiveClass:true,
        responsive:{
            0:{
                nav:false
            },
            600:{

            },
            979:{

            }
        }
      });

      $(".sliderPages").owlCarousel({
        items: 4,
        loop: false,
        center: false,
        autoplay: false,
        mouseDrag: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: false,
        nav: true,
        navText: [ '', '' ],
        dots: false,
        smartSpeed: 700,
        responsiveClass:true,
        responsive:{
            0:{
              items: 1
            },
            840:{
              items: 2
            },
            1420:{

            }
        }
      });


      // Toogle Navigation Mobile

      $('.nav').find('.sub-menu .menu-item-has-children').click(function(){
        // $(this).parent().toggleClass("active");
        //Expand or collapse this panel
        $(".sub-menu .menu-item-has-children").not($(this)).removeClass('active');

        $(this).toggleClass('active');
        // $(this).siblings('.sub-menu').slideDown(500);
        //Hide the other panels

        // if ($(this).parent().hasClass('active')) {
        //   console.log("Open!")
        //   $(this).siblings('.sub-menu').slideDown(500);
        // } else {
        //   console.log("close")
        //   $(this).siblings('.sub-menu').slideUp(500);
        // }

      });

      // Toogle Button Navigation

      $('.nav-button').click(function() {
        $('body').toggleClass('noScroll');
      });


    }

    // AFTER INIT SITE

    /* ==========================================================================
       Fonction bandeau défilant
       ========================================================================== */

    function defilBandeau() {
      $('.bandeauInfos').each(function() {
        var texte = $(this).html();
        $(this).html('<div><span>' + texte + '</span><span>' + texte + '</span></div>');
      });
    }

    if ($(".bandeauInfos").length > 0) {
      defilBandeau();
    }


  });

})(jQuery, this);

(function($, undefined) {
    var isFired = false;
    var oldReady = jQuery.fn.ready;
    $(function() {
        isFired = true;
        $(document).ready();
    });
    jQuery.fn.ready = function(fn) {
        if(fn === undefined) {
            $(document).trigger('_is_ready');
            return;
        }
        if(isFired) {
            window.setTimeout(fn, 1);
        }
        $(document).bind('_is_ready', fn);
    };
})(jQuery);
